export const TagMainObject = {
        //Structure===
        //--Main sector(clients, contacts)
        //------Tag (NA, BN, SC .....)
        //---------------Tag content|structure(name, elements, data.....)
        contacts: {
            //# added new contact tag
            new: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    navbar: {
                        position: "top",
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        }
                    },
                    popup: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "green",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "New contact",
                    alias: "NC",
                    short: "New cont."
                },
                priorityRate: 1,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            //# no answer contact tag
            na: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "red",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "No answer",
                    alias: "NA",
                    short: "N. answ."
                },
                priorityRate: 2,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            //# Schedule call tag
            sc: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "orange",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Schedule call",
                    alias: "SC",
                    short: "Sch. call"
                },
                priorityRate: 3,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            quote: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "bordo",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Quote",
                    alias: "QT",
                    short: "Quote"
                },
                priorityRate: 4,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            projectBuy: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "blue",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Project buy",
                    alias: "PB",
                    short: "P. buy"
                },
                priorityRate: 5,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            projectSell: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "purple",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Project sell",
                    alias: "PS",
                    short: "P. sell"
                },
                priorityRate: 6,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            ended: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "green",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Ended",
                    alias: "END",
                    short: "End."
                },
                priorityRate: 7,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            merged: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "black",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Merged",
                    alias: "MG",
                    short: "Merg."
                },
                priorityRate: 8,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            }
        },
        inventory: {
            //# added new contact tag
            new: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    navbar: {
                        position: "top",
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        }
                    },
                    popup: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "green",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "New contact",
                    alias: "NC",
                    short: "New cont."
                },
                priorityRate: 1,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            //# no answer contact tag
            na: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "red",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "No answer",
                    alias: "NA",
                    short: "N. answ."
                },
                priorityRate: 2,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            //# Schedule call tag
            sc: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "orange",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Schedule call",
                    alias: "SC",
                    short: "Sch. call"
                },
                priorityRate: 3,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            quote: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "bordo",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Quote",
                    alias: "QT",
                    short: "Quote"
                },
                priorityRate: 4,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            projectBuy: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "blue",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Project buy",
                    alias: "PB",
                    short: "P. buy"
                },
                priorityRate: 5,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            projectSell: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "purple",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Project sell",
                    alias: "PS",
                    short: "P. sell"
                },
                priorityRate: 6,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            ended: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "green",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Ended",
                    alias: "END",
                    short: "End."
                },
                priorityRate: 7,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            },
            merged: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    },
                    tooltip: {
                        direction: "top"
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "black",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Merged",
                    alias: "MG",
                    short: "Merg."
                },
                priorityRate: 8,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            }
        },
        clients: {
            deposit: {},
            na: {
                elements: {
                    graph: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: "bars"
                    },
                    modal: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        type: ""
                    },
                    table: {
                        size: {
                            big: {
                                height: "",
                                width: ""
                            },
                            medium: {
                                height: "",
                                width: ""
                            },
                            small: {
                                height: "",
                                width: ""
                            }
                        },
                        sortingOptions: {
                            alphabet: {
                                default: true
                            },
                            numeric: {
                                default: false
                            }
                        },
                        type: ""
                    }
                },
                mainTagStyles: {
                    size: {
                        big: {
                            height: "",
                            width: ""
                        },
                        medium: {
                            height: "",
                            width: ""
                        },
                        small: {
                            height: "",
                            width: ""
                        }
                    },
                    colors: {
                        bgColor: "ccc",
                        fontColor: "ddd",
                        borderColor: "fff"
                    },
                    openDirection: "top"
                },
                name: {
                    title: "Not answer",
                    alias: "NA",
                    short: "N. answ."
                },

                priorityRate: 1,
                triggerEvent: {
                    click: true,
                    hover: false,
                    custom: false
                }
            }
        },
        finance: {},
        shifts: {},
        tasks: {},
        orders: {
           process:{
               elements: {

                   table: {
                       size: {
                           big: {
                               height: "",
                               width: ""
                           },
                           medium: {
                               height: "300px",
                               width: "300px"
                           },
                           small: {
                               height: "",
                               width: ""
                           }
                       },
                       tableColumns: [
                           {
                               title: "date",
                               key: "created_at",
                               widthPercent: 30,
                               id:1
                           },
                           {
                               title: "time",
                               key: "created_at",
                               widthPercent: 30,
                               id:2
                           },
                           {
                               title: "agent",
                               key: "user.full_name",
                               widthPercent: 40,
                               id:3
                           },

                       ],
                   }
               },
               mainTagStyles: {
                   size: {
                       big: {
                           height: "",
                           width: ""
                       },
                       medium: {
                           height: "300px",
                           width: "300px"
                       },
                       small: {
                           height: "",
                           width: ""
                       }
                   },
                   colors: {
                       bgColor: "green",
                       fontColor: "white",
                       borderColor: "green"
                   },
                   openDirection: "top"
               },
               name: {
                   title: "process",
                   alias: "PR",
                   short: "process"
               },

               priorityRate: 1,
               triggerEvent: {
                   click: true,
                   hover: false,
                   custom: false
               }
               },
           order: {},
           images: {},
           finance: {},
           ended: {},
           waitingSupplier: {}
        }

};
